import { useCallback } from "react";

import { SECONDARY_OVERLAY_QUERY_PARAM, SecondaryOverlayType } from "components/constants";
import { useIsXlOrLarger } from "mds/hooks/use-responsive";
import { useAppDispatch } from "store/index";
import { localStateActions } from "store/slices/local";
import { useQueryParamsManager } from "utils/routing";

export const useOverlayControls = (panelName: SecondaryOverlayType) => {
  const dispatch = useAppDispatch();
  const canShowBothSidebars = useIsXlOrLarger();
  const { setQueryParams, deleteQueryParams, getQueryParam } = useQueryParamsManager();
  const currentOverlay = getQueryParam(SECONDARY_OVERLAY_QUERY_PARAM);
  const isSelected = currentOverlay === panelName;

  const togglePanel = useCallback(() => {
    if (isSelected) {
      deleteQueryParams([[SECONDARY_OVERLAY_QUERY_PARAM, panelName]]);
    } else {
      if (!canShowBothSidebars) {
        dispatch(localStateActions.setIsSidebarOpen(false));
      }
      setQueryParams({ [SECONDARY_OVERLAY_QUERY_PARAM]: panelName });
    }
  }, [panelName, isSelected, deleteQueryParams, setQueryParams, canShowBothSidebars, dispatch]);

  return { isSelected, togglePanel };
};
